module.exports = __webpack_public_path__ + "img/4.69763be2.png";